import { useEffect, useState } from 'react';
import { fetchBaseModels } from '@/features/trainings/api/baseModelsApi';

/**
 * Fetch the base-model catalog for ``taskType`` from the backend
 * (``GET /base-models``). Returns the model list and a loading flag.
 *
 * @param {string|undefined} taskType - skip the fetch until known
 * @returns {{ models: {id: string, label: string}[], isLoading: boolean }}
 */
export function useBaseModels(taskType) {
    const [models, setModels] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setModels([]);
        if (!taskType) return undefined;

        let cancelled = false;
        setIsLoading(true);
        fetchBaseModels(taskType)
            .then((data) => {
                if (cancelled) return;
                setModels(Array.isArray(data?.models) ? data.models : []);
            })
            .catch(() => {
                // Non-fatal: the selector still offers "Automatic".
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [taskType]);

    return { models, isLoading };
}
